import { CmsCase } from '@/lib/supabase';

interface CaseOverviewProps {
  caseData: CmsCase;
}

export default function CaseOverview({ caseData }: CaseOverviewProps) {
  const isHtml = caseData.overview?.trim().startsWith('<');

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-12 items-start">
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">项目概述</h2>
            {isHtml ? (
              <div
                className="prose prose-lg max-w-none text-gray-700 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: caseData.overview || '' }}
              />
            ) : (
              <p className="text-lg text-gray-700 leading-relaxed">{caseData.overview}</p>
            )}
          </div>
          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8">
            {caseData.logo_url && (
              <div className="bg-white rounded-xl p-6 mb-6">
                <img src={caseData.logo_url} alt={caseData.client || 'Client'} className="h-16 w-auto mx-auto object-contain" />
              </div>
            )}
            {caseData.metric_value && (
              <div className="text-center">
                <div className="text-5xl font-bold text-teal-600 mb-2">{caseData.metric_value}</div>
                <div className="text-gray-700 font-medium">{caseData.metric_label}</div>
              </div>
            )}
            {!caseData.logo_url && !caseData.metric_value && (
              <div className="text-center py-4">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div className="text-gray-700 font-medium">{caseData.client}</div>
                <div className="text-sm text-gray-500 mt-1">{caseData.industry}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
